import React from "react";

import VerticalRegistry from "../../../constants/verticalRegistry";
import { decryptPhone } from "../utils/encryptedPhone";

const useStudentRouteContext = (location) => {
  return React.useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlPhoneEncrypted = searchParams.get("phone");
    const decryptedPhone = urlPhoneEncrypted ? decryptPhone(urlPhoneEncrypted) : "";
    const vertical = location.state?.vertical || searchParams.get("vertical");
    const verticalInfo = VerticalRegistry.getVerticalByName(vertical);

    return {
      stateStudentData: location.state?.studentData || null,
      statePhone: location.state?.phone || null,
      stateBranchId: location.state?.branch_id || "",
      stateBranchName: location.state?.branch_name || "",
      vertical,
      verticalInfo,
      features: verticalInfo?.features,
      decryptedPhone,
      urlUamId: searchParams.get("uam_id"),
      urlAdmissionNumber: searchParams.get("admission_number"),
      isdCode: searchParams.get("isdCode"),
    };
  }, [location.search, location.state]);
};

export default useStudentRouteContext;
